module.exports = __webpack_public_path__ + "static/media/bgLogin2.66a1d485.png";